import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import dataReducer from './dataReducer';


const store = configureStore({
  reducer: dataReducer,
});

export const persistor = persistStore(store);

export default store;